import { App } from "antd";
import { useTranslation } from "react-i18next";

/**
 * Custom hook for displaying error notifications with i18n support.
 * Provides a consistent way to show error messages across order components.
 *
 * @returns Object containing showError function
 */
export const useErrorNotification = () => {
  const { notification } = App.useApp();
  const { t } = useTranslation();

  const showError = (
    messageKey: string = "error_occurred",
    descriptionKey: string = "please_try_again_later"
  ) => {
    notification.error({
      message: t(messageKey),
      description: t(descriptionKey),
    });
  };

  return { showError };
};
